import React, { useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import FirearmBarrelForm from '../../../components/forms/FirearmBarrelForm';
import { useFirearmBarrelById, useUpdateFirearmBarrel } from '../../../hooks/useFirearmBarrelApi';
import { useNavigate, useParams } from 'react-router-dom';
import Card from '../../../components/common/Card';
import { FirearmBarrelDTO } from '../../../services/apiClient';

const FirearmBarrelEdit: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const { data: entityData, isLoading } = useFirearmBarrelById(id!);
  const updateFirearmBarrel = useUpdateFirearmBarrel();
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Firearm Barrels', href: '/admin/firearmbarrels' },
    { label: 'Edit', href: '#' },
  ];

  const handleSubmit = async (data: any) => {
    try {
      setIsSubmitting(true);
      await updateFirearmBarrel.mutateAsync({ id: id!, data });
      navigate('/admin/firearmbarrels');
    } catch (error) {
      console.error('Error updating FirearmBarrel:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/firearmbarrels"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission='Settings.FirearmBarrel.Edit'
    >
        {entityData ? (
          <FirearmBarrelForm
            initialValues={entityData}
            onSubmit={handleSubmit}
            onCancel={() => navigate('/admin/firearmbarrels')}
          />
        ) : (
          <p>Loading...</p>
        )}
    </AdminLayout>
  );
};

export default FirearmBarrelEdit;